/**
 * Firebase web app config (Project settings → General → Your apps).
 * `measurementId` is optional; kept if you add Google Analytics later.
 */
export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBNcm47xujsccxOaGyw_aPNu6Ri6IzS3Aw',
    authDomain: 'school-form-dc580.firebaseapp.com',
    projectId: 'school-form-dc580',
    storageBucket: 'school-form-dc580.firebasestorage.app',
    messagingSenderId: '501724495258',
    appId: '1:501724495258:web:e1ca5c250a437447254e23',
    measurementId: 'G-9JPCW4L9CB',
  },
};
